import React, { useEffect } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import ContactChat from "../Hellper/ContactChat";
import Brands from "../Images/7.jpg";

const Wholesale = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        padding: "20px",
        maxWidth: "1300px",
        margin: "auto",
        marginTop: "10px",
        "@media (min-width: 1024px)": {
          marginTop: "10px",
        },
      }}
    >
      {/* Main Title */}
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: { xs: "1.75rem", lg: "2rem" },
          fontWeight: "bold",
          textAlign: { xs: "left", md: "center" },
          mb: 4,
        }}
      >
        Wholesale Distribution
      </Typography>

      {/* Introduction Paragraph */}
      <Typography
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.2rem",
          "@media (min-width: 1024px)": { fontSize: "1.4rem" },
          mb: 4,
        }}
      >
        At UK TO MARS LTD, we supply an extensive range of fast-moving consumer
        goods (FMCG) to businesses Worldwide. Our strong partnerships with top
        UK and international brands ensure you benefit from highly competitive
        pricing, reliable supply, and access to the latest product lines.
      </Typography>

      {/* What We Offer Section */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": { fontSize: "1.75rem" },
          mb: 3,
        }}
      >
        What we offer:
      </Typography>

      {/* Two-column layout for content and brands image */}
      <Grid container spacing={4}>
        {/* Left column - Text content */}
        <Grid item xs={12} md={6}>
          <List sx={{ mb: 2 }}>
            {[
              "Comprehensive product catalogues covering confectionery, soft drinks, snacks, groceries, household, and personal care items",
              "Mixed or full pallet ordering, tailored to your needs",
              "Weekly updated stock lists for fresh, in-demand products",
              "Dedicated account management for a smooth and responsive wholesale experience",
              "Convenient order processes, with options for direct Excel/email ordering and WhatsApp catalogue updates",
            ].map((item, index) => (
              <ListItem key={index} sx={{ padding: "4px 0" }}>
                <ListItemText
                  primary={
                    <Typography
                      component="span"
                      sx={{
                        color: "#1D1616",
                        fontSize: "1.2rem",
                        "@media (min-width: 1024px)": { fontSize: "1.3rem" },
                        display: "flex",
                        alignItems: "flex-start",
                      }}
                    >
                      <span style={{ marginRight: "8px" }}>•</span> {item}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>

          <Typography
            variant="body1"
            paragraph
            sx={{
              color: "#1D1616",
              fontSize: "1.2rem",
              "@media (min-width: 1024px)": { fontSize: "1.4rem" },
              mb: 4,
            }}
          >
            Whether you're a retailer, wholesaler, or procurement agent, we help
            your business grow with flexible and scalable wholesale solutions.
          </Typography>
        </Grid>

        {/* Right column - Brands image */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                padding: 2,
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <img
                src={Brands}
                alt="Featured Brands"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "4px",
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <ContactChat />
    </Box>
  );
};

export default Wholesale;
